module.exports = __webpack_public_path__ + "static/img/14010C_2_3_R_20200210_LC.652acaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/14010C_2_3_R_20200210_LC.png
// module id = dKxi
// module chunks = 0